import { render, staticRenderFns } from "./Gamerules.vue?vue&type=template&id=393f108d&scoped=true&"
import script from "./Gamerules.vue?vue&type=script&lang=js&"
export * from "./Gamerules.vue?vue&type=script&lang=js&"
import style0 from "./Gamerules.vue?vue&type=style&index=0&id=393f108d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393f108d",
  null
  
)

export default component.exports